import { gql, useQuery } from "@apollo/client";
import type { GetAllRateAgreements } from "./schema/GetAllRateAgreements";

export const getAllRateAgreementsQuery = gql`
  query GetAllRateAgreements {
    rates {
      allRateAgreements {
        id
        name
        description
        carrier
        serviceMethod
        rateTables {
          id
        }
        lastModifiedAt {
          utcDateTime
        }
        lastModifiedBy
      }
    }
  }
`;

export function useAllRateAgreements() {
  const { data, loading, error } = useQuery<GetAllRateAgreements>(
    getAllRateAgreementsQuery
  );
  const rateAgreements = data?.rates?.allRateAgreements ?? [];
  return {
    rateAgreements,
    loading: loading && rateAgreements.length === 0,
    error
  };
}
